import pc from 'picocolors'

export function signedInMessage(username?: string): string {
  return username ? `Signed in to Vercel as ${pc.cyan(username)}` : 'Signed in to Vercel'
}
